const $ = jQuery;

const init = () => {
	$(document)
		.on('nfFormReady', () => {
			nfRadio.channel('forms')
				.on('before:submit', (e) => {
					const extra = e.get('extra');
					if (window.FL && window.FL.contactFormAppends) {
						if (window.FL.contactFormAppends.adobeTransactionId) {
							extra.adobeTransactionId = window.FL.contactFormAppends.adobeTransactionId;
						}
						if (window.FL.contactFormAppends.adobeVisitorId) {
							extra.adobeVisitorId = window.FL.contactFormAppends.adobeVisitorId;
						}
						if (window.FL.contactFormAppends.adobeReportSuites) {
							extra.adobeReportSuites = window.FL.contactFormAppends.adobeReportSuites;
						}
					}
					e.set('extra', extra);
				});
		});
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/contact-form-appends.js